// extracted by mini-css-extract-plugin
export var checkbox = "_36-0";
export var circle = "_36-3";
export var horizontalContainer = "_36-7";
export var sm = "_36-5";
export var switch0 = "_36-2";
export var switchDisabled = "_36-8";
export var switchEnabled = "_36-1";
export var textSwitchContainer = "_36-9";
export var textSwitchOption = "_36-a";
export var textSwitchOptionSelected = "_36-b";
export var verticalContainer = "_36-6";
export var xs = "_36-4";